import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../components/modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import LabelCustom from '../../../components/label-custom'
import { BsExclamationCircle } from 'react-icons/bs'
import SwalCustomSuccess from '../../../alert/swal-success'
import Error_false from '../../../components/error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import {
  createSettingCostCenterAPI,
  delSettingCostCenterAPI,
  updateSettingCostCenterAPI
} from '../../../services/setting/cost-center'
import UseSettingCostCenterGroup from '../../../hooks/use-cost-center-group'
import AutocompleteCustom from '../../../components/custom/autocomplete'

const schema = yup
  .object({
    costName: yup.string().required('Please choose your cost center (Eng).'),
    costNameTh: yup.string().required('Please choose your Cost Center (TH).'),
    costNameEn: yup.string().required('Please choose your Cost Center (En).'),
    costGroup: yup.object().required('Please choose your Cost Center Number')
  })
  .required()
export default function ModalUpdate({ open, onCancel, fnGetData, data }) {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const costCenterGroup = UseSettingCostCenterGroup()
  const [isSubmit, setIsSubmit] = useState(false)

  useEffect(() => {
    if (data) {
      setValue('costName', data.costName ?? '')
      setValue('costNameTh', data.costNameTh ?? '')
      setValue('costNameEn', data.costNameEn ?? '')
      data.costGroupId &&
        setValue('costGroup', {
          value: data.costGroupId,
          label: data.costGroupName
        })
    }
  }, [data, setValue])

  const onSubmit = async (d) => {
    const body = {
      costName: d.costName,
      costNameTh: d.costNameTh,
      costNameEn: d.costNameEn,
      costGroupId: d.costGroup.value
    }
    if (data) {
      sendAPI(
        updateSettingCostCenterAPI({ ...body, costNumber: data.costNumber })
      )
    } else {
      sendAPI(createSettingCostCenterAPI(body))
    }
  }

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustomSuccess().then(() => {
        fnGetData()
        onCancel()
      })
    } else {
      Error_false(resp)
    }
  }

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'error',
      confirmButtonColor: 'red',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let body = {
          // costName: data.costName,
          costNumber: data.costNumber
        }
        sendAPI(delSettingCostCenterAPI(body))
      }
    })
  }

  return (
    <ModalCustom
      maskClosable={false} // ป้องกันการปิดเมื่อคลิกที่ mask (backdrop)
      keyboard={false} // ป้องกันการปิดเมื่อกดปุ่ม Esc
      open={open}
      onCancel={onCancel}
    >
      <div>
        <h5>{data ? 'Update' : 'Add'} Cost Center</h5>
        <Form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
          <Col xl={6}>
            <LabelCustom text={'Cost Group'} />
            <Controller
              name={'costGroup'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  value={value}
                  onChange={onChange}
                  options={costCenterGroup}
                />
              )}
            />
            {errors.costGroup && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.costGroup.message}
              </span>
            )}
          </Col>

          <Col xl={6}>
            <LabelCustom text={'Cost Name'} />
            <Controller
              name={'costName'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Form.Control
                  maxLength={100}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.costName && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.costName.message}
              </span>
            )}
          </Col>
          <Col xl={12}>
            <LabelCustom text={'Cost Name EN'} />
            <Controller
              name={'costNameEn'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Form.Control
                  maxLength={100}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.costNameEn && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.costNameEn.message}
              </span>
            )}
          </Col>
          <Col xl={12}>
            <LabelCustom text={'Cost Name TH'} />
            <Controller
              name={'costNameTh'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Form.Control
                  maxLength={100}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.costNameTh && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.costNameTh.message}
              </span>
            )}
          </Col>
          <Col xl={12} className="d-flex justify-content-center g-3 gap-3 mt-4">
            <Button variant="light" className="px-4" onClick={onCancel}>
              Close
            </Button>
            {data && (
              <Button
                disabled={isSubmit}
                className="px-4"
                variant="danger"
                onClick={fnDelete}
              >
                Delete{isSubmit && '...'}
              </Button>
            )}
            <Button disabled={isSubmit} type="submit" className="px-4">
              Submit{isSubmit && 'ting...'}
            </Button>
          </Col>
        </Form>
      </div>
    </ModalCustom>
  )
}
